import { render, staticRenderFns } from "./VStickySidebar.vue?vue&type=template&id=6a38ef58&scoped=true&"
import script from "./VStickySidebar.vue?vue&type=script&lang=js&"
export * from "./VStickySidebar.vue?vue&type=script&lang=js&"
import style0 from "./VStickySidebar.vue?vue&type=style&index=0&id=6a38ef58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38ef58",
  null
  
)

export default component.exports